/**
 * @param munchkinIdField {HTMLInputElement}
 * @return {void}
 */
module.exports = function initMunchkinIdFieldValue(munchkinIdField) {
    munchkinIdField.value = "723-YAV-537";
}